import { browserHistory } from 'react-router'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import RichTextEditor from "../../../../common/rich-text/editor.component.jsx"
import ImageUploaderDropZone from "../../../../common/image-uploader/dropzone.component.jsx"
import SectionContentTypes from "../ContentTypes.jsx";
import ColorSelector from "../colorselect.component.jsx";

class TextContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function () { },
            text: content.text || '',
            backgroundImages: content.backgroundImage ? [content.backgroundImage] : [],
            backgroundImageId: content.backgroundImageId || '',
            backgroundColor: content.backgroundColor || '',
            variables: this.props.variables || null, 
        }
        this.handleTextChange = this.handleTextChange.bind(this)
        this.triggerChanged = this.triggerChanged.bind(this)
        this.handleImageChange = this.handleImageChange.bind(this)
        this.handleBackgroundColorChange = this.handleBackgroundColorChange.bind(this)
    }

    componentDidMount() {
        this.triggerChanged()
    }

    triggerChanged() {
        this.state.onChange({
            text: this.state.text,
            backgroundImageId: this.state.backgroundImageId,
            backgroundColor: this.state.backgroundColor,
        })
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}

        this.setState({
            text: content.text || '',
            backgroundImageId: content.backgroundImageId || '',
            backgroundColor: content.backgroundColor || '',
        })
    }

    handleTextChange(value) {
        this.setState({
            text: value
        }, this.triggerChanged)
    }

    handleBackgroundColorChange(value) {
        this.setState({
            backgroundColor: value
        }, this.triggerChanged)
    }

    handleImageChange(images) {
        if (images.length > 0) {
            this.setState({
                backgroundImages: images,
                backgroundImage: images[0],
                backgroundImageId: images[0].id,
            }, this.triggerChanged)
        } else {
            this.setState({
                backgroundImages: [],
                backgroundImage: null,
                backgroundImageId: '',
            }, this.triggerChanged)
        }
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="text">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text.label"
                            defaultMessage="Text"
                        />
                    </label>
                    <div className="col-10">
                        <RichTextEditor
                            enableMergeFields={true}
                            name="text"
                            value={this.state.text}
                            onChange={this.handleTextChange}
                            id="text"
                            variables={this.props.variables}
                            className="form-control"
                            colors={SectionContentTypes.getUniquesColorsFromVariables(this.state.variables)}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text.description"
                                defaultMessage="Text that will be seen on the quote"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="backgroundImages">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text.background_image_label"
                            defaultMessage="Background Image"
                        />
                    </label>
                    <div className="col-10">
                        <ImageUploaderDropZone
                            onUpdateImageList={this.handleImageChange}
                            maxFiles={1}
                            images={this.state.backgroundImages}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text.background_image_description"
                                defaultMessage="This image is applied on the background of the text"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="backgroundColor">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.text.background_color_label"
                            defaultMessage="Background Color"
                        />
                    </label>
                    <div className="col-10">
                        <ColorSelector
                            onChange={this.handleBackgroundColorChange}
                            value={this.state.backgroundColor}
                            variables={this.state.variables}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.text.background_color_description"
                                defaultMessage="This color is applied on the background of the text"
                            />
                        </small>
                    </div>
                </div>
            </div>
        );
    }
}

export default TextContentInput


// WEBPACK FOOTER //
// ./src/template/sections/content/text/input.component.jsx